import { Navigate, createBrowserRouter } from 'react-router-dom';
import { EmptyState } from '@/components/EmptyState/EmptyState';
import { AdminLayout } from '@/features/admin/components/AdminLayout/AdminLayout';
import { AuditPage } from '@/features/admin/pages/AuditPage';
import { CohortDetailPage } from '@/features/admin/pages/CohortDetailPage';
import { CohortsPage } from '@/features/admin/pages/CohortsPage';
import { OverviewPage } from '@/features/admin/pages/OverviewPage';
import { SourcesPage } from '@/features/admin/pages/SourcesPage';
import { AppShell } from '@/features/layout/AppShell/AppShell';
import { ViewerPage } from '@/features/viewer/ViewerPage';

/**
 * Route table. Admin routes are nested under a layout that hides itself from a
 * non-admin principal — presentation only; the Worker is what denies the data
 * behind them (BR-AP1).
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <ViewerPage /> },
      {
        path: 'admin',
        element: <AdminLayout />,
        children: [
          { index: true, element: <OverviewPage /> },
          { path: 'sources', element: <SourcesPage /> },
          { path: 'cohorts', element: <CohortsPage /> },
          { path: 'cohorts/:cohortId', element: <CohortDetailPage /> },
          { path: 'audit', element: <AuditPage /> },
        ],
      },
      { path: 'viewer', element: <Navigate to="/" replace /> },
      {
        path: '*',
        element: (
          <EmptyState title="Page not found" description="That address does not match anything here." />
        ),
      },
    ],
  },
]);
